<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="title-pages">PENDÊNCIAS DE TODAS AS ANOTAÇÕES</h1>
    </div>
    <div class="col-md-12">
      <b-overlay :show="loading" opacity="0.99">
        <div v-show="data.length === 0" class="v-clean p-5">
          <h6 class="text-center upper-text worksansr">
            NÃO EXISTE ANOTAÇÕES PENDENTES!
          </h6>
        </div>
        <div v-show="data.length > 0">
          <v-data-table
            dense
            :headers="headers"
            :items="data"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.date`]="{ item }">
              {{ String(item.created).split("-").reverse().join("/") }}
            </template>
            <template v-slot:[`item.user`]="{ item }">
              Cuidador(a): {{ item.user_name }}
              <br />
              E-mail: {{ item.user_email }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                small
                @click="handleItem(item.created)"
                class="mt-1 mb-1 v-primary"
              >
                <i class="fas fa-arrow-right mr-2"></i>
                ACESSAR
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </b-overlay>
      <ErrorsMessages :errors="errors" />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import api from "../../../services/api";

import routes from "../../../routes";

import { formatDateToUs } from "../../../lib/format";

export default {
  name: "Annotation",

  components: {
    ErrorsMessages,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      headers: [
        { text: "DATA", value: "date", sortable: false },
        { text: "RESPONSÁVEL", value: "user", sortable: false },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],

      resident_id: "",

      data: [],

      errors: [],

      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDateToUs,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.verify();
    },

    async verify() {
      try {
        this.loading = true;

        let { resident_id } = this;

        let params = { resident_id };

        const response = await api.get(
          "/rest-home/resident/pending-verification/annotation",
          {
            params,
          }
        );

        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleItem(date) {
      this.$emit("pendingVerification", {
        tab: "check",
        nav: "annotation",
        date: formatDateToUs(date),
      });
    },
  },
};
</script>
